import React, { Component } from 'react';
import 'antd/dist/antd.css';
import './Footer.css';
import '../../globalcss.css';
import fbimg from '../../Images/fb.png';
import twitterimg from '../../Images/twitter.png';
import youtubeimg from '../../Images/youtube.png';
import { NavLink } from 'react-router-dom';
import { Row, Col, Menu, Icon } from 'antd';

class Footer extends Component {
    render() {
        return (
            <div className="footersec">
                <div className="container">
                    <Row type="flex" justify="center">
                        <Col lg={{ span: 7 }} xs={{ span: 24 }}>
                        <div className="footerpad">
                            <p className="footercont"> Tap<span>Me</span>Now </p>
                            <p className="subcont text-left">
                                There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour.
                                </p>
                                </div>
                        </Col>
                        <Col lg={{ span: 7 }} xs={{ span: 24 }}>
                            <div className="footerpad ml1em">
                                <h3 className="footerhead"> <span>Useful Links </span></h3>

                                <Menu className="footeritem bnone">
                                    <Menu.Item key="about">
                                       About
                                       <NavLink to="/about"></NavLink>
                                    </Menu.Item>
                                    <Menu.Item key="browse">
                                        Browse
                                        <NavLink to="/browse"></NavLink>
                                    </Menu.Item>
                                    <Menu.Item key="create">
                                        Contact
                                        <NavLink to="/contact"></NavLink>
                                    </Menu.Item>
                                    <Menu.Item key="support">
                                        Support
                                    </Menu.Item>
                                </Menu>
                            </div>
                        </Col>
                        <Col lg={{ span: 7 }} xs={{ span: 24 }}>
                            <div className="footerpad">
                            <h3 className="footerhead"> <span>Get In Touch </span></h3>
                            <p className="footercontact m0 text-left"><span><Icon type="phone" className="white" />
                            123-456-7890</span><br></br>
                            <span><Icon type="mail" className="white" /> abc@gmail.com</span>
                            <br></br><span> <Icon type="environment-o" className="white" /> 23Avenue Park Road</span>
                             </p>
                              <ul className="socialicon">
                              <li>
                              <img src={fbimg} alt="About" />
                              </li>
                              <li>
                              <img src={twitterimg} alt="About" />
                              </li>
                              <li>
                              <img src={youtubeimg} alt="About" />
                              </li>
                              </ul>
                            </div>
                        </Col>
                    </Row>
                    <div className="stickyfooter">
                      <p className="float-left"> Copyright © TapMeNow 2018.  All Rights Reserved
                      </p>
                      <p className="float-right"> Design and Developed with <Icon type="heart" /> by <a href="https://underscoretec.com/" target="_blank">Underscoretec</a></p>
                    </div>
                </div>
            </div>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/Component/Footer/Footer.js